import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import GameNotificationPopup from "../components/One-to-one-games/Game-notification-popup/GameNotificationPopup";
import { useDispatch, useSelector } from "react-redux";
import MobileAppAlert from "../shared/sharedComponents/mobile-app-alert/MobileAppAlert";
import { getLocalStorageData } from "../shared/commonFunction";
import { setUser } from "../features/user/userSlice";

const Layout = () => {
  const isLogin = useSelector((state) => state.login.isLogin);
  const isAds = useSelector((state) => state.ads.isAdsShow);
  const location = useLocation();
  const dispatch = useDispatch();
  const path = location.pathname;
  const [shouldShowAds, setShouldShowAds] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(getLocalStorageData("user") || "{}");
    if (userData && Object.keys(userData).length > 0) {
      dispatch(setUser(userData));
    }
  }, [dispatch]);

  // Rest of your component code
  return (
    <div className="bg-color">
      <div className="navbar-mobile-ads">
        {isAds && path === "/" && <MobileAppAlert />}
        {!(path === "/delete-account") ? <Navbar /> : null}
      </div>
      {isLogin && <GameNotificationPopup />}
      <Outlet />
      {!(path === "/delete-account") ? <Footer /> : null}
    </div>
  );
};

export default Layout;
